// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"168":"4227514c","230":"18b1a9de","289":"65735eb8","388":"b17e765e","501":"b8085df3","527":"ff831cdc","613":"b6753e36","696":"948f52bd","728":"c2beef9f","758":"2e44fa21","911":"458d02fc","936":"320e61b0"}[chunkId] + ".js";
};